<form [formGroup]="cancelarForm">
    <h2 style="width: 375px;" mat-dialog-title>Cancelar tarea</h2>
    <mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-label>Comentario</mat-label>
            <textarea matInput formControlName="comentario"></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close cdkFocusInitial>Cancelar</button>
        <button type="submit" mat-flat-button (click)="onSubmitForm()"
            [disabled]="!cancelarForm.valid || fetchingCancelarTarea">
            <div class="btn-login-content">
                @if (fetchingCancelarTarea) {
                <mat-spinner diameter="20" color="warn"></mat-spinner>
                }@else{
                <p>Aceptar</p>
                }
            </div>
        </button>
    </mat-dialog-actions>
</form>